module.exports = __webpack_public_path__ + "img/btn_shitu_you.9c4d1d35.png";